import { Button, styled, Box } from '@mui/material';

export const RootStyled = styled(Box)({
  padding: 19,
  paddingBottom: 34,
  border: '1px solid #707070',
  borderRadius: '8px',
});

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90vw',
  height: '50vh',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 16,
});

export const ButtonsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '16px',
  marginTop: '16px',
});

export const BtnStyled = styled(Button)(({ theme }) => ({
  height: 40,
  color: theme.palette.primary.contrastText,
  padding: '0 32px',
}));

export const BtnSecondaryStyled = styled(Button)(({ theme }) => ({
  height: 40,
  color: theme.palette.primary.contrastText,
  fontFamily: theme.typography.button,
  padding: '0 32px',
}));

export const DefaultPageStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 30,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 50,
  },
}));
